import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';
import { MdOutlineBlock, MdSearch, MdMode, MdDelete, MdRemoveRedEye, MdDownload, MdClose } from "react-icons/md";
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Sort from '../../assets/image/sort-down-alt.svg';
import Filter from '../../assets/image/filter.svg';
import Dummy from '../../assets/image/user-circle.svg';
import Pagination from '../../Components/Pagination/Pagination';
import { handleApiCall } from '../../apis';
import { endpoint } from '../../utils/endpoints';
import { toast } from 'react-toastify';
import Toastify from '../../utils/tostfy';
import fileCSV from '../../assets/File/Program.csv'
import Loader from '../../Components/Loader/Loader';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import CustomDatePicker from '../../Components/CustomDatePicker';
import { FaCalendarAlt } from 'react-icons/fa';
import * as XLSX from 'xlsx';

function Reports() {
    const navigate = useNavigate();
    const location = useLocation();
    const storedState = JSON.parse(localStorage.getItem("Reports")) || {};
    const [totalPages, setTotalPages] = useState(storedState.totalPages || 0);
    const [total, setTotal] = useState(storedState.total || 0);
    const [page, setPage] = useState(storedState.page || 1);
    const [perPage, setPerPage] = useState(storedState.perPage || 10);
    const [search, setSearch] = useState(storedState.search || "");
    const [indexNumber, setIndexNumber] = useState(storedState.indexNumber || 0);
    const [user, setUser] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [districtList, setDistrictList] = useState([]);
    const [blockList, setBlockList] = useState([]);
    const [regionIds, setRegionIds] = useState([]);
    const [countryIds, setCountryIds] = useState([]);
    const [stateIds, setStateIds] = useState([]);
    const [districtIds, setDistrictIds] = useState([]);
    const [blockIds, setBlockIds] = useState([]);
    const [innner, setInner] = useState("Teacher")
    const [openDropdown, setOpenDropdown] = useState(null);
    const [filter_data, setfilter_data] = useState({
        region_id: regionIds,
        country_id: countryIds,
        state_id: stateIds,
        district_id: districtIds,
        block_id: blockIds
    });

    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState(1);
    const isRestoringState = useRef(true);
    const [activeTab, setActiveTab] = useState("tab1");
    // Initialize filter data and fetch initial data
    useEffect(() => {
        getRegionList();
        fetchTabData(activeTab);

        // Clean up restoration flag after initial load
        const timer = setTimeout(() => {
            isRestoringState.current = false;
        }, 100);

        return () => clearTimeout(timer);
    }, []);

    // Fetch data when dependencies change (pagination must send custom filter + dates when filter === 3)
    useEffect(() => {
        if (!isRestoringState.current) {
            const fetchWithCurrentFilters = () => {
                if (filter === 3 && fromDate && toDate) {
                    fetchTabData(activeTab, 3, fromDate, toDate);
                } else {
                    fetchTabData(activeTab);
                }
            };

            let timer;
            if (search) {
                timer = setTimeout(fetchWithCurrentFilters, 5000);
            } else {
                fetchWithCurrentFilters();
            }
            return () => clearTimeout(timer);
        }
    }, [filter_data, page, perPage, search, innner]);


    // Update filter_data when any filter IDs change
    useEffect(() => {
        setfilter_data({
            region_id: regionIds,
            country_id: countryIds,
            state_id: stateIds,
            district_id: districtIds,
            block_id: blockIds
        });
    }, [regionIds, countryIds, stateIds, districtIds, blockIds]);

    // Fetch dependent lists when parent IDs change
    useEffect(() => {
        if (regionIds.length) getCountryList(); else setCountryList([]);
    }, [regionIds]);

    useEffect(() => {
        if (countryIds.length) getStateList(); else setStateList([]);
    }, [countryIds]);

    useEffect(() => {
        if (stateIds.length) getDistrictList(); else setDistrictList([]);
    }, [stateIds]);

    useEffect(() => {
        if (districtIds.length) getBlockList(); else setBlockList([]);
    }, [districtIds]);

    const toggleSelection = (id, setState, currentState) => {
        setState(
            currentState.includes(id)
                ? currentState.filter((item) => item !== id)
                : [...currentState, id]
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const paginationHandler = (e, i) => {
        e.preventDefault();
        if (i !== page) {
            setPage(i);
            const newIndexNumber = perPage * (i - 1);
            setIndexNumber(newIndexNumber);
        }
    };

    const handleNavigation = (path, data) => {
        localStorage.setItem(
            "programManagementState",
            JSON.stringify({
                totalPages,
                total,
                page,
                perPage,
                search,
                indexNumber,
                filter_data,
            })
        );
        navigate(path, { state: { ...data, fromPage: true } });
    };

    const resetFilters = () => {
        setRegionIds([]);
        setCountryIds([]);
        setStateIds([]);
        setDistrictIds([]);
        setBlockIds([]);
    };

    const handleTabClick = (tabKey) => {
        setFilter(1)
        setUser([]);
        setSearch("");
        setPage(1);
        setIndexNumber(0);
        setActiveTab(tabKey);
        fetchTabData(tabKey, 1); // Direct API call
    };



    const tabToEndpointIndex = {
        tab1: 0,
        tab2: 1,
        tab3: 2,
        tab4: 3,
        tab5: 4,
        tab6: 5,
        tab7: 6,
        tab8: 7,
    };

    const endpoints = [
        endpoint?.teacherUsageIndicator,
        endpoint.coachUsageIndicator,
        endpoint.coachVisitTargetAchievement,
        endpoint.teacherVisitTargetAchievement,
        endpoint.reviewingCoachInteraction,
        endpoint.reviewingTeacherInteraction,
        endpoint.teacherKeyInsight,
        endpoint.indicatorTracking,
    ];

    const tabConfig = {
        tab1: { key: "teacherList", setter: setUser },
        tab2: { key: "coachList", setter: setUser },
        tab3: { key: "coachList", setter: setUser },
        tab4: { key: "teacherList", setter: setUser },
        tab5: { key: "observationList", setter: setUser },
        tab6: { key: "observationList", setter: setUser },
        tab7: { key: "teacherInsightList", setter: setUser },
        tab8: { key: "teacherInsightList", setter: setUser }
    };

    const fetchTabData = async (tabKey, filterVal = filter, from = null, to = null) => {
        setLoading(true);
        const endpointIndex = tabToEndpointIndex[tabKey];
        const apiUrl = endpoints[endpointIndex];
        if (!apiUrl) return;

        try {
            let url = `${apiUrl}?page=${page}&limit=${perPage}&search_query=${search}`;

            // ✅ Add teacher type if tabKey is tab8
            if (tabKey === "tab8") {
                url += `&type=${innner}`;
            }

            // Add date filters if provided
            if (from && to) {
                url += `&from_date=${ApiDate(from)}&to_date=${ApiDate(to)}&filter=${filterVal}`;
            } else if (filterVal && filterVal !== "custom_date") {
                url += `&filter=${filterVal}`;
            }

            // Create filtered filter_data object (only include non-empty arrays)
            const filteredFilterData = Object.entries(filter_data).reduce((acc, [key, value]) => {
                if (value.length > 0) {
                    acc[key] = value;
                }
                return acc;
            }, {});

            // Only add filter_data if it has any values
            if (Object.keys(filteredFilterData).length > 0) {
                url += `&filter_data=${encodeURIComponent(JSON.stringify(filteredFilterData))}`;
            }

            const response = await handleApiCall("get", url, {});

            if (response?.data?.code === 200) {
                setLoading(false);
                const { key, setter } = tabConfig[tabKey] || {};
                if (key && setter) {
                    setter(response?.data?.data?.[key] || []);
                }
                setTotalPages(response?.data?.data?.total_pages);
                setTotal(response?.data?.data?.total);
            } else if (response?.response?.data?.success === false) {
                console.log(response?.response?.data?.errorMessage);
                setTimeout(() => {
                    navigate("/");
                }, 2000);
            }
        } catch (e) {
            console.log("Error fetching tab data:", e);
            setLoading(false);
        }
    };


    // API functions for filter lists
    const getRegionList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterRegion}`, {});
            if (response?.data?.code === 200) setRegionList(response.data.data);
        } catch (e) {
            console.log("Error fetching region list:", e);
        }
    };

    const getCountryList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterCountry}?region_id=${JSON.stringify(regionIds)}`);
            if (response?.data?.code === 200) setCountryList(response.data.data);
        } catch (e) {
            console.log("Error fetching country list:", e);
        }
    };

    const getStateList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterState}?country_id=${JSON.stringify(countryIds)}`, {});
            if (response?.data?.code === 200) setStateList(response.data.data);
        } catch (e) {
            console.log("Error fetching state list:", e);
        }
    };

    const getDistrictList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterDistrict}?state_id=${JSON.stringify(stateIds)}`, {});
            if (response?.data?.code === 200) setDistrictList(response.data.data);
        } catch (e) {
            console.log("Error fetching district list:", e);
        }
    };

    const getBlockList = async () => {
        try {
            const response = await handleApiCall("get", `${endpoint.filterBlock}?district_id=${JSON.stringify(districtIds)}`, {});
            if (response?.data?.code === 200) setBlockList(response.data.data);
        } catch (e) {
            console.log("Error fetching block list:", e);
        }
    };



    const [showDropdown, setShowDropdown] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [showCustomPicker, setShowCustomPicker] = useState(false);

    const dropdownRef = useRef(null);


    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setShowDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // ✅ Auto-close custom date when both selected
    useEffect(() => {
        if (selectedOption === 'custom_date' && fromDate && toDate) {
            const timeout = setTimeout(() => {
                setShowCustomPicker(false);
                setShowDropdown(false);
            }, 300);
            return () => clearTimeout(timeout);
        }
    }, [fromDate, toDate, selectedOption]);

    const ApiDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const exportToExcel = async () => {
        setLoading(true);
        try {
            // Get endpoint for current tab
            const endpointIndex = tabToEndpointIndex[activeTab];
            const apiUrl = endpoints[endpointIndex];
            if (!apiUrl) {
                toast.error("Export not available for this tab");
                return;
            }

            // Build API URL - fetch ALL data without pagination
            let url = `${apiUrl}?page=1&limit=${total || 10000}&search_query=${search}`;
            if (activeTab === "tab8") {
                url += `&type=${innner}`;
            }

            // Apply filters
            const filteredFilterData = Object.entries(filter_data).reduce((acc, [key, value]) => {
                if (value.length > 0) acc[key] = value;
                return acc;
            }, {});
            if (Object.keys(filteredFilterData).length > 0) {
                url += `&filter_data=${encodeURIComponent(JSON.stringify(filteredFilterData))}`;
            }

            // Apply date filters
            if (filter === 3 && fromDate && toDate) {
                url += `&from_date=${ApiDate(fromDate)}&to_date=${ApiDate(toDate)}&filter=${filter}`;
            } else if (filter && filter !== "custom_date") {
                url += `&filter=${filter}`;
            }

            // Fetch all data
            const response = await handleApiCall("get", url, {});
            if (response?.data?.code === 200) {
                const { key } = tabConfig[activeTab] || {};
                const allData = response?.data?.data?.[key] || [];

                if (allData.length === 0) {
                    toast.warning("No data to export");
                    return;
                }

                let formattedData = [];

                // ✅ TAB 1: Teacher Usage Indicators - EXACT same as table
                if (activeTab === "tab1") {
                    formattedData = allData.map((item, index) => ({
                        "Sr.No.": index + 1,
                        "Region": item.teacher_region_name || "-",
                        "Country": item.teacher_country_name || "-",
                        "State": item.teacher_state_name || "-",
                        "Block": item.teacher_block_name || "-",
                        "Program Name": item.program_name || "-",
                        "Teacher Name": item.teacher_name || item.full_name || "-",
                        "Enrollment Month (The Month the Teacher was added)": item.teacher_added_date ? formatDate(item.teacher_added_date) : "-",
                        "Assigned Coach": item.coach_full_name || "-",
                        "Grade 1 or 2 or both": item.teacher_grade || "-",
                        "Total no. of Sessions": item.totalNoOfSession ?? "-",
                        "Number of session by video": item.videoCount ?? "-",
                        "Average time per session for video": item.average_time_observation ?? "-",
                        "Number of sessions by questionnaire": item.formCount ?? "-",
                        "No of interaction with AI Pilot outside of the session (no of days)": item.aiPilotSessionCount ?? "-",
                    }));
                }
                // ✅ TAB 2: Coach Usage Indicators - EXACT same as table
                else if (activeTab === "tab2") {
                    formattedData = allData.map((item, index) => ({
                        "Sr.No.": index + 1,
                        "Region": item.coach_region_name || "-",
                        "Country": item.coach_country_name || "-",
                        "State": item.coach_state_name || "-",
                        "Block": item.coach_block_name || "-",
                        "Coach Name": item.full_name || "-",
                        "Total Schools": item.total_school ?? 0,
                        "No.Of teacher assigned": item.total_teacher ?? 0,
                        "PO/PA": item.po_pa || "-",
                        "Total no. of sessions": item.total_no_session_count ?? 0,
                        "Average time for observation (with internet or without internet)": item.average_time_of_observation ?? 0,
                        "No. Of Interaction With AI Pilot Outside Of The Session (no of days)": item.no_of_interaction_with_ai_piolt_outside ?? 0,
                        "Target Achievment Ratio for teacher visit": item.target_achievment_ratio_for_teacher_visit || "-",
                    }));
                }
                // ✅ TAB 3: Coach Visit Target Achievement - EXACT same as table
                else if (activeTab === "tab3") {
                    formattedData = allData.map((item, index) => ({
                        "Sr.No.": index + 1,
                        "Region": item?.coach_location?.region?.name || "-",
                        "Country": item?.coach_location?.country?.name || "-",
                        "State": item?.coach_location?.state?.name || "-",
                        "Block": item?.coach_location?.block?.name || "-",
                        "Coach Name": item?.full_name || "-",
                        "PO/PA": item?.po_pa || "-",
                        "No. of School": item?.noOfSchool ?? 0,
                        "No.Of Teachers": item?.noOfTeachers ?? 0,
                        "Month": item?.enrollment_month || "-",
                        "Total no. of (Sessions This Month)": item?.noOfSessions ?? 0,
                        "School visit Ratio": item?.schoolVisitRatio ?? "-",
                        "Target Visit Ratio": item?.teacherVisitRatio ?? "-",
                        "Numbers Of Teachers P1": item?.priorityCounts?.P1 ?? 0,
                        "Numbers Of Teachers P2": item?.priorityCounts?.P2 ?? 0,
                        "Numbers Of Teachers P3": item?.priorityCounts?.P3 ?? 0,
                    }));
                }
                // ✅ TAB 4: Teacher Progress Against Priority - EXACT same as table
                else if (activeTab === "tab4") {
                    formattedData = allData.map((item, index) => {
                        let gradeDisplay = "-";
                        if (Array.isArray(item.teacher_grade) && item.teacher_grade.length > 0) {
                            if (item.teacher_grade.length === 2) {
                                gradeDisplay = "Both";
                            } else {
                                gradeDisplay = item.teacher_grade[0].grade_name;
                            }
                        }

                        return {
                            "Sr.No.": index + 1,
                            "Region": item?.teacher_region_name || "-",
                            "Country": item?.teacher_country_name || "-",
                            "State": item?.teacher_state_name || "-",
                            "Block": item?.teacher_block_name || "-",
                            "Teacher Name": item?.full_name || "-",
                            "Program name": item?.program_name || "-",
                            "Enrollment month": item.enrollment_month || "-",
                            "Assigned Coach": item?.coach_full_name || "-",
                            "Grade 1,2 both": gradeDisplay,
                            "Baseline Priority Area beginning of the year or First observation": item?.baseline_priority_area_first_observation || "-",
                            "Baseline month +1": item?.baseline_month_plus1 || "-",
                            "Baseline month +2": item?.baseline_month_plus2 || "-",
                            "Baseline month +3": item?.baseline_month_plus3 || "-",
                            "Total Sessions By Coach": item?.total_sessions_by_coach ?? "-",
                            "Total Sessions by Teacher questionnaire": item?.total_session_by_teacher_by_form ?? "-",
                            "Total Sessions by Teacher video": item?.total_session_by_teacher_by_video ?? "-",
                            "Total number of action items given by coach": item?.total_no_of_action_items_given_by_coach ?? "-",
                            "Action items given by coach completed by teacher": item?.action_items_given_coach_completed_by_teacher ?? "-",
                            "Action items given by AI in teacher video/questionnaire": item?.action_items_given_by_ai_in_teacher ?? "-",
                            "Action items given by Ai completed by teacher": item?.action_items_given_by_ai_completed_by_teacher ?? "-"
                        };
                    });
                }
                // ✅ TAB 5: Reviewing Coach Interactions - EXACT same as table
                else if (activeTab === "tab5") {
                    formattedData = allData.map((data, index) => {
                        // Format action plans exactly like in table
                        const actionPlans = data?.action_plan_generation_post_observation?.map((plan, planIndex) =>
                            `${planIndex + 1}. ${plan.action_plan_name}`
                        ).join('\n') || "-";

                        const finalActionPlans = data?.final_action_plan?.map((plan, planIndex) =>
                            `${planIndex + 1}. ${plan.action_plan_name}`
                        ).join('\n') || "-";

                        return {
                            "Sr.No.": index + 1,
                            "Region": data?.region_name || "-",
                            "Country": data?.country_name || "-",
                            "State": data?.state_name || "-",
                            "District": data?.district_name || "-",
                            "Block": data?.block_name || "-",
                            "Coach Name": data?.coach_full_name || "-",
                            "PO/PA": data?.po_pa || "-",
                            "Session Date": data?.session_date || "-",
                            "Teacher Name": data?.teacher_full_name || "-",
                            "Action plan generation post observation": actionPlans,
                            "Topics Selected For AI feedback before teacher interaction": actionPlans, // Same as above like in table
                            "AI Feedback Given": data?.ai_feedback_given?.[0]?.summary || "—",
                            "Final Action Plan": finalActionPlans,
                            "Reference material given": "-",
                        };
                    });
                }
                // ✅ TAB 6: Reviewing Teacher Interactions - EXACT same as table
                else if (activeTab === "tab6") {
                    formattedData = allData.map((item, index) => {
                        // Format topics exactly like in table
                        const topics = item?.action_plan_generation_post_observation?.map((plan, planIndex) =>
                            `${planIndex + 1}. ${plan.action_plan_name}`
                        ).join('\n') || "-";

                        return {
                            "Sr.No.": index + 1,
                            "Region": item.region_name || "-",
                            "Country": item.country_name || "-",
                            "State": item.state_name || "-",
                            "District": item.district_name || "-",
                            "Block": item.block_name || "-",
                            "Teacher Name": item.teacher_full_name || "-",
                            "School Name": item.school_name || "-",
                            "Coach Name": item.coach_name || "-",
                            "Session Date": item.session_date ? formatDate(item.session_date) : "-",
                            "Video or Questionnaire": item.observation_type === "video" ? "Video" :
                                item.observation_type === "form" ? "Questionnaire" : "-",
                            "AI Feedback Post Session Input": item.ai_feedback_given?.[0]?.summary || "-",
                            // "Topics Selected For Feedback": topics,
                            // "AI Feedback Given Against Selected Areas": item.ai_feedback_given?.[0]?.strengths?.length ?
                            // item.ai_feedback_given[0].strengths.join(", ") : "-",
                            "Action Plan with Action Item": item.action_plan_generation_post_observation?.[0]?.action_plan_name || "-",
                            // "Last Coach Action Plan": item.final_action_plan?.[0]?.action_plan_name || "-",
                            "Reference Materials": item.reference_materials || "-",
                        };
                    });
                }
                else if (activeTab === "tab7") {
                    formattedData = allData.map((item, index) => {
                        // Function to get questions exactly like in table
                        const getQuestions = (observationData, limit = 10) => {
                            if (!Array.isArray(observationData)) return [];

                            const questions = [];
                            const seenQuestions = new Set();

                            observationData.forEach(observation => {
                                if (observation.observationQuestions && Array.isArray(observation.observationQuestions)) {
                                    observation.observationQuestions.forEach(obsQuestion => {
                                        if (obsQuestion.questionData?.question && !seenQuestions.has(obsQuestion.questionData.question)) {
                                            seenQuestions.add(obsQuestion.questionData.question);
                                            questions.push(obsQuestion.questionData.question);
                                            if (questions.length >= limit) return;
                                        }
                                    });
                                }
                                if (questions.length >= limit) return;
                            });

                            return questions.slice(0, limit);
                        };

                        // Function to get action plans exactly like in table
                        const getActionPlans = (actionPlanData, limit = 10) => {
                            if (!Array.isArray(actionPlanData)) return [];

                            const actionPlans = [];
                            const seenPlans = new Set();

                            actionPlanData.forEach(observation => {
                                if (observation.actionPlans && Array.isArray(observation.actionPlans)) {
                                    observation.actionPlans.forEach(actionPlan => {
                                        if (actionPlan.action_plan_name && !seenPlans.has(actionPlan.action_plan_name)) {
                                            seenPlans.add(actionPlan.action_plan_name);
                                            actionPlans.push(actionPlan.action_plan_name);
                                            if (actionPlans.length >= limit) return;
                                        }
                                    });
                                }
                                if (actionPlans.length >= limit) return;
                            });

                            return actionPlans.slice(0, limit);
                        };

                        // Get all the data arrays
                        const overallGapQuestions = getQuestions(item.overall_gap_area_for_teachers);
                        const overallGapQuestionsCoach = getQuestions(item.overall_gap_area_for_coach);
                        const leadingGapQuestionnaire = getQuestions(item.leading_gap_area_by_in_questionnaire);
                        const leadingGapAI = getQuestions(item.leadingGap_area_by_identified_AI_video_analysis);
                        const coachActionPlans = getActionPlans(item.leading_action_items_by_coach);
                        const aiVideoActionPlans = getActionPlans(item.leading_action_items_by_ai_through_teacher_video);
                        const aiQuestionnaireActionPlans = getActionPlans(item.leading_action_items_by_ai_through_teacher_questionnaire);

                        return {
                            "Sr.No.": index + 1,
                            "Region": item.region_name || "-",
                            "Country": item.country_name || "-",
                            "State": item.state_name || "-",
                            "Block": item.block_name || "-",
                            "Month": item.enrollment_month || "-",

                            // Column 1: Overall gap areas for teacher
                            "Overall gap areas for teacher": overallGapQuestions.length > 0
                                ? overallGapQuestions.map((q, i) => `${i + 1}. ${q}`).join('\n')
                                : "-",
                            "No. of teachers (Overall gap)": item?.overall_gap_area_for_teachers_count?.toString() || "0",

                            // Column 2: Leading Coach Observations Gap Areas
                            "Leading Coach Observations Gap Areas": overallGapQuestionsCoach.length > 0
                                ? overallGapQuestionsCoach.map((q, i) => `${i + 1}. ${q}`).join('\n')
                                : "-",
                            "No. of teachers (Coach Observations)": item?.overall_gap_area_for_coach_count?.toString() || "0",

                            // Column 3: Leading gap areas by teacher in (questionnarire)
                            "Leading gap areas by teacher in (questionnarire)": leadingGapQuestionnaire.length > 0
                                ? leadingGapQuestionnaire.map((q, i) => `${i + 1}. ${q}`).join('\n')
                                : "-",
                            "No. of teachers (Questionnaire)": item?.leading_gap_area_by_in_questionnaire_count?.toString() || "0",

                            // Column 4: Leading gap areas by identified by AI in video analaysis
                            "Leading gap areas by identified by AI in video analaysis": leadingGapAI.length > 0
                                ? leadingGapAI.map((q, i) => `${i + 1}. ${q}`).join('\n')
                                : "-",
                            "No. of teachers (AI Video)": item?.leadingGap_area_by_identified_AI_video_analysis_count?.toString() || "0",

                            // Column 5: Leading action items by coach
                            "Leading action items by coach": coachActionPlans.length > 0
                                ? coachActionPlans.map((ap, i) => `${i + 1}. ${ap}`).join('\n')
                                : "-",
                            "No. of teachers (Coach Actions)": item?.leading_action_items_by_coach_count?.toString() || "0",

                            // Column 6: Leading action items by AI through teacher video
                            "Leading action items by AI through teacher video": aiVideoActionPlans.length > 0
                                ? aiVideoActionPlans.map((ap, i) => `${i + 1}. ${ap}`).join('\n')
                                : "-",
                            "No. of teachers (AI Video Actions)": item?.leading_action_items_by_ai_through_teacher_video_count?.toString() || "0",

                            // Column 7: Leading actions item by AI through teacher quenstionnaire
                            "Leading actions item by AI through teacher quenstionnaire": aiQuestionnaireActionPlans.length > 0
                                ? aiQuestionnaireActionPlans.map((ap, i) => `${i + 1}. ${ap}`).join('\n')
                                : "-",
                            "No. of teachers (AI Questionnaire Actions)": item?.leading_action_items_by_ai_through_teacher_questionnaire_count?.toString() || "0",

                            "Top reference material for coach": "-",
                            "Top reference material by teacher": "-",
                        };
                    });
                }
                // ✅ TAB 8: Indicator Tracking - EXACT same as table
                else if (activeTab === "tab8") {
                    formattedData = allData.map((data, index) => {
                        const probes = ["A", "B", "C", "D", "E"].reduce((acc, probe, idx) => {
                            const reason = data?.question_reason?.[idx];
                            acc[`Probe ${probe}`] = reason?.reason || "-";
                            acc[`Number Probe ${probe}`] = reason?.selectedCount ?? 0;
                            return acc;
                        }, {});

                        return {
                            "Sr.No.": index + 1,
                            "Indicator": data?.question || "-",
                            "Total observation": data?.total_observation ?? 0,
                            "Month/time range": data?.month_time || "-",
                            "Number of marked no": data?.total_number_of_question_no ?? 0,
                            ...probes,
                            // 👇 Matches the table display (shows question text)
                            "Indicator selected for feedback": data?.question || "-",
                        };
                    });
                }


                // ✅ Create Excel sheet with proper formatting
                const ws = XLSX.utils.json_to_sheet(formattedData);

                // Auto-size columns for better Excel display
                if (formattedData.length > 0) {
                    const colWidths = Object.keys(formattedData[0]).map(key => {
                        const maxLength = Math.max(
                            key.length,
                            ...formattedData.map(row => String(row[key] || '').length)
                        );
                        return { wch: Math.min(Math.max(maxLength + 2, 12), 60) };
                    });
                    ws['!cols'] = colWidths;
                }

                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, ws, "Report Data");

                // ✅ File naming
                const tabNames = {
                    tab1: "Teacher_Usage_Indicators",
                    tab2: "Coach_Usage_Indicators",
                    tab3: "Coach_Visit_Target_Achievement",
                    tab4: "Teacher_Progress_Against_Priority",
                    tab5: "Reviewing_Coach_Interactions",
                    tab6: "Reviewing_Teacher_Interactions",
                    tab7: "Teacher_Key_Insights",
                    tab8: "Indicator_Tracking"
                };
                const fileName = `${tabNames[activeTab]}_${new Date().toISOString().split('T')[0]}.xlsx`;

                // ✅ Export file
                XLSX.writeFile(wb, fileName);
                toast.success("Data exported successfully!");

            } else {
                toast.error("Failed to fetch data for export");
            }
        } catch (error) {
            console.error("Export error:", error);
            toast.error("Error during export");
        } finally {
            setLoading(false);
        }
    };






    return (
        <>
            <Loader isLoading={loading} />
            <div className="px-4 py-2">
                {/* Tab Buttons */}
                <div className="flex flex-wrap gap-2 mb-4">
                    {[
                        { key: "tab1", label: "Teacher Usage\nIndicators" },
                        { key: "tab2", label: "Coach Usage\nIndicators" },
                        { key: "tab3", label: "Coach Visit Target\nAchievement" },
                        { key: "tab4", label: "Teacher Progress\nAganist Priority" },
                        { key: "tab5", label: "Reviewing Coach\nInteractions" },
                        { key: "tab6", label: "Reviewing Teachers\nInteractions" },
                        { key: "tab7", label: "Teacher Key\nInsights" },
                        { key: "tab8", label: "Indicator\nTracking" },
                    ].map(({ key, label }) => (
                        <button
                            key={key}
                            onClick={() => handleTabClick(key)}
                            className={`custom-tab px-3 py-1 h-[66px] text-[16px] font-semibold rounded-md leading-tight
                                ${activeTab === key
                                    ? "bg-[#994263] text-white"
                                    : "bg-[#E5DED4] text-[#444444] hover:bg-gray-300"
                                }`}
                            style={{
                                whiteSpace: 'pre-line',
                                minWidth: '166px',
                                maxWidth: '198px',
                            }}
                        >
                            {label}
                        </button>
                    ))}
                </div>

                {activeTab === "tab8" ? <div className="flex flex-wrap gap-2 mb-4">
                    {["Teacher", "Coach"].map((item) => (
                        <button
                            key={item}
                            onClick={() => setInner(item)}
                            className={`custom-tab px-3 py-1 h-[40px] text-[14px] font-semibold rounded-md leading-tight
        ${innner === item
                                    ? "bg-[#994263] text-white"
                                    : "bg-[#E5DED4] text-[#444444] hover:bg-gray-300"
                                }`}
                            style={{
                                minWidth: "120px",
                                maxWidth: "160px",
                            }}
                        >
                            {item}
                        </button>
                    ))}
                </div> : null}



                <div className='my-3  w-full px-2 sm:px-4'>
                    <div className='flex flex-col sm:flex-row justify-between gap-2'>
                        <div className="flex  gap-2 justify-center sm:justify-start ">
                            {/* Search input with icon */}
                            <div>
                                <label className="relative block w-full sm:w-auto">
                                    <span className="sr-only">Search</span>
                                    <div className="relative w-full">
                                        <span className="absolute inset-y-0 left-0 flex items-center pl-2">
                                            <svg className="h-5 w-5 fill-slate-500" viewBox="0 0 20 20">
                                                <path
                                                    fillRule="evenodd"
                                                    d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </span>
                                        <input
                                            className="placeholder:text-gray-400 block bg-gray-200 rounded-md w-full border border-slate-300 py-2.5 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-base"
                                            placeholder="Search"
                                            type="text"
                                            name="Search"
                                            value={search}
                                            maxLength={150}
                                            onChange={(e) => {
                                                let value = e.target.value;

                                                // Remove leading spaces or special characters
                                                value = value.replace(/^[\s\W_]+/, "");

                                                setSearch(value);
                                            }}
                                        />
                                    </div>
                                </label>
                            </div>



                        </div>
                        {activeTab? <div className='flex flex-wrap gap-2 items-center justify-center sm:justify-start'>
                            <button onClick={resetFilters} className="bg-[#F0D7E0] py-2 px-4 rounded-md mb-2 font-bold text-[15px]">All</button>
                            {[
                                { name: "Region", list: regionList, ids: regionIds, setState: setRegionIds },
                                { name: "Country", list: countryList, ids: countryIds, setState: setCountryIds },
                                { name: "State", list: stateList, ids: stateIds, setState: setStateIds },
                                { name: "District", list: districtList, ids: districtIds, setState: setDistrictIds },
                                { name: "Block", list: blockList, ids: blockIds, setState: setBlockIds }
                            ].map(({ name, list, ids, setState }) => (
                                <Dropdown
                                    key={name}
                                    className="mb-2"
                                    show={openDropdown === name}
                                    onToggle={(isOpen) => setOpenDropdown(isOpen ? name : null)}
                                >
                                    <Dropdown.Toggle
                                        variant="light"
                                        className="text-dark w-full sm:w-auto"
                                        style={{ backgroundColor: "#F0D7E0", border: "0", borderRadius: "5px", fontSize: "15px", fontWeight: "bold" }}
                                    >
                                        {ids.length ? `${name}` : name}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {list.length === 0 ? (
                                            <Dropdown.Item disabled>No {name} available</Dropdown.Item>
                                        ) : (
                                            list.map((item) => (
                                                <Dropdown.Item key={item._id} as="div" className="d-flex align-items-center">
                                                    <Form.Check
                                                        type="checkbox"
                                                        checked={ids.includes(item._id)}
                                                        onChange={() => toggleSelection(item._id, setState, ids)}
                                                        label={item.name}
                                                        className="text-black"
                                                        style={{ fontSize: "15px" }}
                                                    />
                                                </Dropdown.Item>
                                            ))
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            ))}
                        </div> : null}
                        {/* Calendar icon button */}
                        <div className='flex flex-wrap gap-3  justify-center sm:justify-start'>
                            <div className=' flex justify-end'>
                                <div className="relative" ref={dropdownRef}>
                                    <button
                                        onClick={() => {
                                            setShowDropdown((prev) => !prev);
                                            setShowCustomPicker(false);
                                        }}
                                        className="p-2 bg-[#F6F6F6] border border-black rounded-md"
                                    >
                                        <FaCalendarAlt size={20} />
                                    </button>

                                    {showDropdown && (
                                        <div className="absolute right-0 mt-2 bg-white border border-gray-300 rounded shadow-md z-10 w-56">
                                            <button
                                                onClick={() => {
                                                    fetchTabData(activeTab, 1);
                                                    setFilter(1);
                                                    setShowDropdown(false);
                                                }}
                                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                            >
                                                This Month
                                            </button>
                                            <button
                                                onClick={() => {
                                                    fetchTabData(activeTab, 2);
                                                    setFilter(2);
                                                    setShowDropdown(false);
                                                }}
                                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                            >
                                                Last 3 Months
                                            </button>
                                            <button
                                                onClick={() => {
                                                    setShowCustomPicker(true);
                                                    setShowDropdown(false);
                                                    setFromDate(null);
                                                    setToDate(null);
                                                }}
                                                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                                            >
                                                Custom Date
                                            </button>
                                        </div>
                                    )}

                                    {/* ✅ Show custom date picker when enabled */}
                                    {showCustomPicker && (
                                        <div className="absolute right-0 mt-2 bg-white px-4 pt-3 pb-4 border border-black rounded-md shadow-md z-20 w-[320px] text-sm">
                                            {/* Cancel X button */}
                                            <div className="flex justify-end mb-2">
                                                <button
                                                    onClick={() => {
                                                        setFromDate(null);
                                                        setToDate(null);
                                                        setShowCustomPicker(false);
                                                        setShowDropdown(false);
                                                    }}
                                                    className="w-6 h-6 text-white text-xl font-bold hover:text-red-800 border border-[#994263] bg-[#994263] rounded-full flex items-center justify-center"
                                                    title="Cancel"
                                                >
                                                    ×
                                                </button>
                                            </div>


                                            {/* Date fields */}
                                            <div className="flex flex-col gap-2">
                                            
                                              {/* FROM DATE */}
                                              <div className="flex flex-col">
                                                <label className="mb-1 font-medium">From:</label>
                                                <CustomDatePicker
                                                  selected={fromDate}
                                                  onChange={(date) => {
                                                    setFromDate(date);
                                                    setToDate(null); // clear old To-date
                                                  }}
                                                  placeholder="Select from date"
                                                  dateFormat="yyyy-MM-dd"
                                                  minDate={null}
                                                  maxDate={null}
                                                />
                                              </div>
                                            
                                              {/* TO DATE */}
                                              <div className="flex flex-col">
                                                <label className="mb-1 font-medium">To:</label>
                                                <CustomDatePicker
                                                  selected={toDate}
                                                  onChange={(date) => setToDate(date)}
                                                  placeholder="Select to date"
                                                  dateFormat="yyyy-MM-dd"
                                                  maxDate={new Date()}
                                                  minDate={null}
                                                />
                                              </div>
                                            </div>

                                            {/* Submit button */}
                                            {fromDate && toDate && (
                                                <button
                                                    onClick={() => {
                                                        // Pass filter value = 3 and the selected dates
                                                        fetchTabData(activeTab, 3, fromDate, toDate);
                                                        setFilter(3);
                                                        setShowCustomPicker(false);
                                                        setShowDropdown(false);
                                                    }}
                                                    className="mt-3 w-full py-1.5 bg-[#994263] text-white rounded-md hover:bg-gray-900 transition"
                                                >
                                                    Submit
                                                </button>
                                            )}
                                        </div>
                                    )}

                                </div>
                            </div>
                            <label
                                onClick={exportToExcel}
                                className="text-[#994263] py-2 font-bold inline-flex cursor-pointer justify-center px-3 items-center hover:bg-[#e6e0e2] border-[#994263] rounded-md border-[2px] w-full sm:w-auto"
                            >
                                Export CSV
                            </label>

                        </div>
                    </div>
                </div>



                {/* Tab Content */}
                <div className="mt-6">
                    {activeTab === "tab1" && <div className="common-table-wrapper m-0">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='text-center align-top'>Sr.No.</th>
                                        <th className='align-top'>Region</th>
                                        <th className='align-top'>Country</th>
                                        <th className='align-top'>State</th>
                                        <th className='align-top'>Block</th>
                                        <th className='align-top'>
                                            Program Name
                                        </th>
                                        <th className='align-top'>
                                            Teacher
                                            Name
                                        </th>
                                        <th className='align-top'>
                                            Enrollment Month <br />
                                            ( The Month the Teacher was added)
                                        </th>
                                        <th className='align-top'>
                                            Assigned <br />
                                            Coach
                                        </th>
                                        <th className='align-top'>
                                            Grade 1 or 2 <br />
                                            or both
                                        </th>
                                        <th className='align-top'>
                                            Total no. of <br />
                                            Sessions
                                        </th>
                                        <th className='align-top'>
                                            Number of <br />
                                            session by video
                                        </th>
                                        <th className='align-top'>
                                            Average time per <br />
                                            session for video
                                        </th>
                                        <th className='align-top'>
                                            Number of sessions <br />
                                            by questionnaire
                                        </th>
                                        <th className='align-top'>
                                            No of interaction with  <br />
                                            AI Pilot outside of the session (no of days)
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.length > 0 ? (
                                        user.map((item, i) => {
                                            return (
                                                <tr key={item._id} className="align-top">
                                                    {/* Sr.No. */}
                                                    <td className="text-center align-top">{indexNumber + i + 1}</td>

                                                    {/* Region */}
                                                    <td className="align-top">{item.teacher_region_name || "-"}</td>

                                                    {/* Country */}
                                                    <td className="align-top">{item.teacher_country_name || "-"}</td>

                                                    {/* State */}
                                                    <td className="align-top">{item.teacher_state_name || "-"}</td>

                                                    {/* Block */}
                                                    <td className="align-top">{item.teacher_block_name || "-"}</td>

                                                    {/* Program Name */}
                                                    <td className="align-top">{item.program_name || "-"}</td>

                                                    {/* Teacher Name */}
                                                    <td className="align-top">{item.teacher_name || item.full_name || "-"}</td>

                                                    {/* Enrollment Month */}
                                                    <td className="align-top">{item.teacher_enrollment_month || "-"}</td>

                                                    {/* Assigned Coach */}
                                                    <td className="align-top">{item.coach_full_name || "-"}</td>

                                                    {/* Grade 1 or 2 (or both) */}
                                                    <td className="align-top">{item.teacher_grade}</td>

                                                    {/* Total no. of Sessions */}
                                                    <td className="align-top">{item.totalNoOfSession ?? "-"}</td>

                                                    {/* Number of sessions by video */}
                                                    <td className="align-top">{item.videoCount ?? "-"}</td>

                                                    {/* Average time per session for video */}
                                                    <td className="align-top">{item.average_time_observation ?? "-"}</td>

                                                    {/* Number of sessions by questionnaire */}
                                                    <td className="align-top">{item.formCount ?? "-"}</td>

                                                    {/* No. of All pilot ou */}
                                                    <td className="align-top">{item.aiPilotSessionCount ?? "-"}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="100%" className="text-center text-lg align-top">
                                                No Data Found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {activeTab === "tab2" && <div className="common-table-wrapper m-0">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='text-center align-top'>Sr.No.</th>
                                        <th className='align-top'>Region</th>
                                        <th className='align-top'>Country</th>
                                        <th className='align-top'>State</th>
                                        <th className='align-top'>Block</th>
                                        <th className='align-top'>
                                            Coach  <br />
                                            Name
                                        </th>
                                        <th className='align-top'>
                                            Total <br />
                                            Schools
                                        </th>
                                        <th className='align-top'>
                                            No.Of teacher <br />
                                            assigned
                                        </th>
                                        <th className='align-top'>
                                            PO/PA <br />
                                        </th>
                                        <th className='align-top'>
                                            Total no. of <br />
                                            sessions
                                        </th>
                                        <th className='align-top'>
                                            Average time for observation  <br />
                                            (with internet or without internet)
                                        </th>
                                        <th className='align-top'>
                                            No. Of Interaction <br />
                                            With AI Pilot Outside
                                            Of The Session (no of days)
                                        </th>
                                        <th className='text-center align-top'>
                                            Target Achievment Ratio <br />
                                            for teacher visit
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.length > 0 ? (
                                        user.map((item, i) => (
                                            <tr key={item?._id} className="align-top">
                                                {/* Sr.No. */}
                                                <td className="text-center align-top">{indexNumber + i + 1}</td>

                                                {/* Region */}
                                                <td className="align-top">{item?.coach_region_name || "-"}</td>

                                                {/* Country */}
                                                <td className="align-top">{item?.coach_country_name || "-"}</td>

                                                {/* State */}
                                                <td className="align-top">{item?.coach_state_name || "-"}</td>

                                                {/* Block */}
                                                <td className="align-top">{item?.coach_block_name || "-"}</td>

                                                {/* Coach Name */}
                                                <td className="align-top">{item?.full_name || "-"}</td>

                                                {/* Total Schools */}
                                                <td className="align-top">{item?.total_school ?? 0}</td>

                                                {/* No. of teacher assigned */}
                                                <td className="align-top">{item?.total_teacher ?? 0}</td>

                                                {/* PO/PA */}
                                                <td className="align-top">{item?.po_pa || "-"}</td>

                                                {/* Total no. of sessions */}
                                                <td className="align-top">{item?.total_no_session_count ?? 0}</td>

                                                {/* Average time for observation */}
                                                <td className="align-top">{item?.average_time_of_observation ?? 0}</td>

                                                {/* No. of Interaction with AI Pilot Outside */}
                                                <td className="align-top">{item?.no_of_interaction_with_ai_piolt_outside ?? 0}</td>

                                                {/* Target Achievement Ratio */}
                                                <td className="text-center align-top">
                                                    {item?.target_achievment_ratio_for_teacher_visit || "-"}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr className="align-top">
                                            <td colSpan="100%">
                                                <h6 className="text-center text-lg align-top">No Program Found.</h6>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {activeTab === "tab3" && <div className="common-table-wrapper m-0">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='text-center align-top'>Sr.No.</th>
                                        <th className='align-top'>Region</th>
                                        <th className='align-top'>Country</th>
                                        <th className='align-top'>State</th>
                                        <th className='align-top'>Block</th>
                                        <th className='align-top'>
                                            Coach
                                            Name
                                        </th>
                                        <th className='align-top'>
                                            PO/PA
                                        </th>
                                        <th className='align-top'>
                                            No. of
                                            School
                                        </th>
                                        <th className='align-top'>
                                            No.Of
                                            Teachers
                                        </th>
                                        <th className='align-top'>
                                            Month
                                        </th>
                                        <th className='align-top'>
                                            Total no. of <br />
                                            (Sessions This Month)
                                        </th>
                                        <th className='align-top'>
                                            School visit
                                            Ratio
                                        </th>
                                        <th className='align-top'>
                                            Target Visit
                                            Ratio
                                        </th>
                                        <th className='align-top'>
                                            Numbers Of <br />
                                            Teachers P1
                                        </th>
                                        <th className='align-top'>
                                            Numbers Of <br />
                                            Teachers P2
                                        </th>
                                        <th className='align-top'>
                                            Numbers Of <br />
                                            Teachers P3
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.length > 0 ? user.map((item, i) => {
                                        return (
                                            <tr key={item?._id} className="align-top">
                                                <td className='text-center align-top'>{indexNumber + i + 1}</td>
                                                <td className="align-top">{item?.coach_location?.region?.name}</td>
                                                <td className="align-top">{item?.coach_location?.country?.name}</td>
                                                <td className="align-top">{item?.coach_location?.state?.name}</td>
                                                <td className="align-top">{item?.coach_location?.block?.name}</td>
                                                <td className="align-top">{item?.full_name}</td>
                                                <td className="align-top">{item?.po_pa}</td>
                                                <td className="align-top">{item?.noOfSchool}</td>
                                                <td className="align-top">{item?.noOfTeachers}</td>
                                                <td className="align-top">{item?.enrollment_month || "-"}</td>
                                                <td className="align-top">{item?.noOfSessions}</td>
                                                <td className="align-top">{item?.schoolVisitRatio}</td>
                                                <td className="align-top">{item?.teacherVisitRatio}</td>
                                                <td className="align-top">{item?.priorityCounts?.P1}</td>
                                                <td className="align-top">{item?.priorityCounts?.P2}</td>
                                                <td className='text-center align-top'>{item?.priorityCounts?.P3}</td>
                                            </tr>
                                        );
                                    })
                                        :
                                        <tr className="align-top">
                                            <td colSpan="100%">
                                                <h6 className="text-center text-lg align-top">No Program Found.</h6>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {activeTab === "tab4" && <div className="common-table-wrapper m-0">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="text-center align-top">Sr.No.</th>
                                        <th className="align-top">Region</th>
                                        <th className="align-top">Country</th>
                                        <th className="align-top">State</th>
                                        <th className="align-top">Block</th>
                                        <th className="align-top">
                                            Teacher <br />
                                            Name
                                        </th>
                                        <th className="align-top">
                                            Program <br />
                                            name
                                        </th>
                                        <th className="align-top">
                                            Enrollment <br />
                                            month
                                        </th>
                                        <th className="align-top">
                                            Assigned <br />
                                            Coach
                                        </th>
                                        <th className="align-top">
                                            Grade 1,2 <br />
                                            both
                                        </th>
                                        <th className="align-top">
                                            Baseline Priority Area <br />
                                            beginning of the year or First observation
                                        </th>
                                        <th className="align-top">
                                            Baseline month <br />
                                            +1
                                        </th>
                                        <th className="align-top">
                                            Baseline month <br />
                                            +2
                                        </th>
                                        <th className="align-top">
                                            Baseline month <br />
                                            +3
                                        </th>
                                        <th className="align-top">
                                            Total Sessions <br />
                                            By Coach
                                        </th>
                                        <th className="align-top">
                                            Total Sessions by Teacher <br />
                                            questionnaire
                                        </th>
                                        <th className="align-top">
                                            Total Sessions by Teacher <br />
                                            video
                                        </th>
                                        <th className="align-top">
                                            Total number of action items <br />
                                            given by coach
                                        </th>
                                        <th className="align-top">
                                            Action items given by coach <br />
                                            completed by teacher
                                        </th>
                                        <th className="align-top">
                                            Action items given by AI in teacher <br />
                                            video/questionnaire
                                        </th>
                                        <th className="align-top">
                                            Action items given by Ai <br />
                                            completed by teacher
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.length > 0 ? (
                                        user.map((item, i) => {
                                            let gradeDisplay = "-";
                                            if (Array.isArray(item.teacher_grade) && item.teacher_grade.length > 0) {
                                                if (item.teacher_grade.length === 2) {
                                                    gradeDisplay = "Both";
                                                } else {
                                                    gradeDisplay = item.teacher_grade[0].grade_name;
                                                }
                                            }

                                            return (
                                                <tr key={item?._id} className="align-top">
                                                    <td className="text-center align-top">{indexNumber + i + 1}</td>
                                                    <td className="align-top">{item?.teacher_region_name}</td>
                                                    <td className="align-top">{item?.teacher_country_name}</td>
                                                    <td className="align-top">{item?.teacher_state_name}</td>
                                                    <td className="align-top">{item?.teacher_block_name}</td>
                                                    <td className="align-top">{item?.full_name}</td>
                                                    <td className="align-top">{item?.program_name}</td>
                                                    <td className="align-top">{item?.enrollment_month || "-"}</td>
                                                    <td className="align-top">{item?.coach_full_name}</td>
                                                    <td className="align-top">{gradeDisplay}</td>
                                                    <td className="align-top">{item?.baseline_priority_area_first_observation || "-"}</td>
                                                    <td className="align-top">{item?.baseline_month_plus1 || "-"}</td>
                                                    <td className="align-top">{item?.baseline_month_plus2 || "-"}</td>
                                                    <td className="align-top">{item?.baseline_month_plus3 || "-"}</td>
                                                    <td className="align-top">{item?.total_sessions_by_coach ?? "-"}</td>
                                                    <td className="align-top">{item?.total_session_by_teacher_by_form ?? "-"}</td>
                                                    <td className="align-top">{item?.total_session_by_teacher_by_video ?? "-"}</td>
                                                    <td className="align-top">{item?.total_no_of_action_items_given_by_coach ?? "-"}</td>
                                                    <td className="align-top">{item?.action_items_given_coach_completed_by_teacher ?? "-"}</td>
                                                    <td className="align-top">{item?.action_items_given_by_ai_in_teacher ?? "-"}</td>
                                                    <td className="align-top">{item?.action_items_given_by_ai_completed_by_teacher ?? "-"}</td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr className="align-top">
                                            <td colSpan="100%">
                                                <h6 className="text-center text-lg align-top">No Program Found.</h6>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {activeTab === "tab5" && <div className="common-table-wrapper m-0">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='text-center align-top'>Sr.No.</th>
                                        <th className='align-top'>Region</th>
                                        <th className='align-top'>Country</th>
                                        <th className='align-top'>State</th>
                                        <th className='align-top'>District</th>
                                        <th className='align-top'>Block</th>
                                        <th className='align-top'>
                                            Coach  <br />
                                            Name
                                        </th>
                                        <th className='align-top'>
                                            PO/PA
                                        </th>
                                        <th className='align-top'>
                                            Session <br />
                                            Date
                                        </th>
                                        <th className='align-top'>
                                            Teacher <br />
                                            Name
                                        </th>
                                        <th className='align-top'>
                                            Action plan generation <br />
                                            post observation
                                        </th>
                                        <th className='align-top'>
                                            Topics Selected For <br />
                                            AI feedback before teacher interaction
                                        </th>
                                        <th className='align-top'>
                                            AI Feedback Given
                                        </th>
                                        <th className='align-top'>
                                            Final Action Plan
                                        </th>
                                        <th className='align-top'>
                                            Reference material given
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.length > 0 ? user.map((data, i) => {
                                        return (
                                            <tr key={data?._id} className="align-top">
                                                <td className='text-center align-top'>{indexNumber + i + 1}</td>
                                                <td className="align-top">{data?.region_name}</td>
                                                <td className="align-top">{data?.country_name}</td>
                                                <td className="align-top">{data?.state_name}</td>
                                                <td className="align-top">{data?.district_name}</td>
                                                <td className="align-top">{data?.block_name}</td>
                                                <td className="align-top">{data?.coach_full_name}</td>
                                                <td className="align-top">{data?.po_pa}</td>
                                                <td className="align-top">{formatDate(data?.session_date)}</td>
                                                <td className="align-top">{data?.teacher_full_name}</td>
                                                <td className="align-top">
                                                    <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                        {data?.final_action_plan?.map((plan, index) => (
                                                            <div key={plan._id} style={{ marginBottom: "6px" }}>
                                                                {index + 1}. {plan.action_plan_name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>

                                                <td className="align-top">
                                                    <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                        {data?.action_plan_generation_post_observation?.map((plan, index) => (
                                                            <div key={index} style={{ marginBottom: "5px" }}>
                                                                <div style={{ marginBottom: "4px" }}>
                                                                    {index + 1}. {plan.action_plan_name}
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>

                                                <td className="align-top">
                                                    <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                        {data?.ai_feedback_given?.[0]?.summary || "—"}
                                                    </div>
                                                </td>

                                                <td className="align-top">
                                                    <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                        {data?.final_action_plan?.map((plan, index) => (
                                                            <div key={plan._id} style={{ marginBottom: "6px" }}>
                                                                {index + 1}. {plan.action_plan_name}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </td>
                                                <td className='text-center align-top'>{"-"}</td>
                                            </tr>
                                        );
                                    })
                                        :
                                        <tr className="align-top">
                                            <td colSpan="100%">
                                                <h6 className="text-center text-lg align-top">No Program Found.</h6>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {activeTab === "tab6" && (
                        <div className="common-table-wrapper m-0">
                            <div className="table-responsive">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="text-center align-top">Sr.No.</th>
                                            <th className="align-top">Region</th>
                                            <th className="align-top">Country</th>
                                            <th className="align-top">State</th>
                                            <th className="align-top">District</th>
                                            <th className="align-top">Block</th>
                                            <th className="align-top">Teacher Name</th>
                                            <th className="align-top">School Name</th>
                                            <th className="align-top">Coach Name</th>
                                            <th className="align-top">Session Date</th>
                                            <th className="align-top">Video or Questionnaire</th>
                                            <th className="align-top">AI Feedback Post Session Input</th>
                                            {/* <th className="align-top">Topics Selected For Feedback</th> */}
                                            {/* <th className="align-top">AI Feedback Given Against Selected Areas</th> */}
                                            <th className="align-top">Action Plan with Action Item</th>
                                            {/* <th className="align-top">Last Coach Action Plan</th> */}
                                            <th className="align-top">Reference Materials</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {user?.length > 0 ? (
                                            user.map((item, i) => (
                                                <tr key={item.observation_id} className="align-top">
                                                    {/* Sr.No */}
                                                    <td className="text-center align-top">{indexNumber + i + 1}</td>

                                                    {/* Region */}
                                                    <td className="align-top">{item.region_name || "-"}</td>

                                                    {/* Country */}
                                                    <td className="align-top">{item.country_name || "-"}</td>

                                                    {/* State */}
                                                    <td className="align-top">{item.state_name || "-"}</td>

                                                    {/* District */}
                                                    <td className="align-top">{item.district_name || "-"}</td>

                                                    {/* Block */}
                                                    <td className="align-top">{item.block_name || "-"}</td>

                                                    {/* Teacher Name / Unique ID */}
                                                    <td className="align-top">{item.teacher_full_name || "-"}</td>

                                                    {/* School Name */}
                                                    <td className="align-top">{item.school_name || "-"}</td>

                                                    {/* Coach Name */}
                                                    <td className="align-top">{item.coach_name || "-"}</td>

                                                    {/* Session Date */}
                                                    <td className="align-top">{item.session_date ? formatDate(item.session_date) : "-"}</td>

                                                    {/* Video or Questionnaire */}
                                                    <td className="align-top">
                                                        {item.observation_type === "video"
                                                            ? "Video"
                                                            : item.observation_type === "form"
                                                                ? "Questionnaire"
                                                                : "-"}
                                                    </td>

                                                    {/* AI Feedback Post Session Input */}
                                                    <td className="align-top">
                                                        <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                            {item.ai_feedback_given?.[0]?.summary || "-"}
                                                        </div>
                                                    </td>

                                                    {/* Topics Selected For Feedback */}
                                                    {/* <td className="align-top">
                                                        <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                            {item?.action_plan_generation_post_observation?.map((plan, index) => (
                                                                <div key={index} style={{ marginBottom: "5px" }}>
                                                                    <div style={{ marginBottom: "4px" }}>
                                                                        {index + 1}. {plan.action_plan_name}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </td> */}

                                                    {/* AI Feedback Given Against Selected Areas */}
                                                    {/* <td className="align-top">
                                                        <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                            {item.ai_feedback_given?.[0]?.strengths?.length
                                                                ? item.ai_feedback_given[0].strengths.join(", ")
                                                                : "-"}
                                                        </div>
                                                    </td> */}

                                                    {/* Action Plan with Action Item */}
                                                    <td className="align-top">
                                                        <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                            {item.action_plan_generation_post_observation?.[0]?.action_plan_name || "-"}
                                                        </div>
                                                    </td>

                                                    {/* Last Coach Action Plan */}
                                                    {/* <td className="align-top">
                                                        <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                            {item.final_action_plan?.[0]?.action_plan_name || "-"}
                                                        </div>
                                                    </td> */}

                                                    {/* Reference Materials */}
                                                    <td className="align-top">{item.reference_materials || "-"}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr className="align-top">
                                                <td colSpan="100%">
                                                    <h6 className="text-center text-lg align-top">No Observation Found.</h6>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {activeTab === "tab7" && <div className="common-table-wrapper m-0">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="text-center align-top">Sr.No.</th>
                                        <th className="align-top">Region</th>
                                        <th className="align-top">Country</th>
                                        <th className="align-top">State</th>
                                        <th className="align-top">Block</th>
                                        <th className="align-top">Month</th>
                                        <th className="align-top">Overall gap areas<br /> for teacher</th>
                                        <th className="align-top">No. of teachers</th>
                                        <th className="align-top">Leading Coach Observations<br />Gap Areas</th>
                                        <th className="align-top">No. of teachers</th>
                                        <th className='text-center align-top'>Leading gap <br /> areas by teacher<br /> in (questionnarire)</th>
                                        <th className="align-top">No. of teachers</th>
                                        <th className='text-center align-top'>Leading gap areas<br /> by identified by AI <br />in video analaysis</th>
                                        <th className="align-top">No. of teachers</th>
                                        <th className='text-center align-top'>Leading action<br /> items by coach</th>
                                        <th className="align-top">No. of teachers</th>
                                        <th className='text-center align-top'>Leading action <br />items by AI through<br /> teacher video</th>
                                        <th className="align-top">No. of teachers</th>
                                        <th className='text-center align-top'>Leading actions item <br />by AI through teacher <br />quenstionnaire</th>
                                        <th className="align-top">No. of teachers</th>
                                        <th className='text-center align-top'>Top reference material<br /> for coach</th>
                                        <th className='text-center align-top'>Top reference material<br /> by teacher</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.length > 0 ? user.map((item, i) => {
                                        const getFirst10Questions = (gapAreaData) => {
                                            if (!Array.isArray(gapAreaData)) return [];

                                            const allQuestions = [];
                                            const seenQuestions = new Set();

                                            gapAreaData.forEach(observation => {
                                                if (observation.observationQuestions && Array.isArray(observation.observationQuestions)) {
                                                    observation.observationQuestions.forEach(obsQuestion => {
                                                        if (obsQuestion.questionData &&
                                                            obsQuestion.questionData.question &&
                                                            !seenQuestions.has(obsQuestion.questionData.question)) {

                                                            seenQuestions.add(obsQuestion.questionData.question);
                                                            allQuestions.push(obsQuestion.questionData.question);

                                                            if (allQuestions.length >= 10) return;
                                                        }
                                                    });
                                                }
                                                if (allQuestions.length >= 10) return;
                                            });

                                            return allQuestions.slice(0, 10);
                                        };

                                        const getActionPlanNames = (actionPlanData) => {
                                            if (!Array.isArray(actionPlanData)) return [];

                                            const allActionPlans = [];
                                            const seenActionPlans = new Set();

                                            actionPlanData.forEach(observation => {
                                                if (observation.actionPlans && Array.isArray(observation.actionPlans)) {
                                                    observation.actionPlans.forEach(actionPlan => {
                                                        if (actionPlan.action_plan_name && !seenActionPlans.has(actionPlan.action_plan_name)) {
                                                            seenActionPlans.add(actionPlan.action_plan_name);
                                                            allActionPlans.push(actionPlan.action_plan_name);

                                                            if (allActionPlans.length >= 10) return;
                                                        }
                                                    });
                                                }
                                                if (allActionPlans.length >= 10) return;
                                            });

                                            return allActionPlans.slice(0, 10);
                                        };

                                        const overallGapQuestions = getFirst10Questions(item.overall_gap_area_for_teachers || []);
                                        const leadingGapQuestionnaire = getFirst10Questions(item.leading_gap_area_by_in_questionnaire || []);
                                        const leadingGapAI = getFirst10Questions(item.leadingGap_area_by_identified_AI_video_analysis || []);
                                        const coachActionPlans = getActionPlanNames(item.leading_action_items_by_coach || []);
                                        const aiVideoActionPlans = getActionPlanNames(item.leading_action_items_by_ai_through_teacher_video || []);
                                        const aiQuestionnaireActionPlans = getActionPlanNames(item.leading_action_items_by_ai_through_teacher_questionnaire || []);
                                        const overallGapQuestionsCoach = getFirst10Questions(item.overall_gap_area_for_coach || item.overall_gap_area_for_coach || []);

                                        return (
                                            <tr key={item._id} className="align-top">
                                                <td className="text-center align-top">{indexNumber + i + 1}</td>
                                                <td className="align-top">{item.region_name || "-"}</td>
                                                <td className="align-top">{item.country_name || "-"}</td>
                                                <td className="align-top">{item.state_name || "-"}</td>
                                                <td className="align-top">{item.block_name || "-"}</td>
                                                <td className="align-top">{item.enrollment_month || "-"}</td>
                                                <td className="align-top">
                                                    {overallGapQuestions.length > 0 ? (
                                                        <div className="max-w-xs max-h-32 overflow-y-auto">
                                                            {overallGapQuestions.map((question, index) => (
                                                                <div key={index} className="text-xs mb-2 p-1 break-words whitespace-normal border-b border-gray-100 last:border-b-0">
                                                                    <span className="font-semibold">{index + 1}.</span> {question}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="max-w-xs">-</div>
                                                    )}
                                                </td>
                                                <td className="text-center align-top">
                                                    {item.overall_gap_area_for_teachers_count || "0"}
                                                </td>
                                                <td className="align-top">
                                                    {overallGapQuestionsCoach.length > 0 ? (
                                                        <div className="max-w-xs max-h-32 overflow-y-auto">
                                                            {overallGapQuestionsCoach.map((question, index) => (
                                                                <div key={index} className="text-xs mb-2 p-1 break-words whitespace-normal border-b border-gray-100 last:border-b-0">
                                                                    <span className="font-semibold">{index + 1}.</span> {question}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="max-w-xs">-</div>
                                                    )}
                                                </td>
                                                <td className="text-center align-top">
                                                    {item.overall_gap_area_for_coach_count || "0"}
                                                </td>
                                                <td className="align-top">
                                                    {leadingGapQuestionnaire.length > 0 ? (
                                                        <div className="max-w-xs max-h-32 overflow-y-auto">
                                                            {leadingGapQuestionnaire.map((question, index) => (
                                                                <div key={index} className="text-xs mb-2 p-1 break-words whitespace-normal border-b border-gray-100 last:border-b-0">
                                                                    <span className="font-semibold">{index + 1}.</span> {question}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="max-w-xs">-</div>
                                                    )}
                                                </td>
                                                <td className="text-center align-top">
                                                    {item.leading_gap_area_by_in_questionnaire_count || "0"}
                                                </td>
                                                <td className="align-top">
                                                    {leadingGapAI.length > 0 ? (
                                                        <div className="max-w-xs max-h-32 overflow-y-auto">
                                                            {leadingGapAI.map((question, index) => (
                                                                <div key={index} className="text-xs mb-2 p-1 break-words whitespace-normal border-b border-gray-100 last:border-b-0">
                                                                    <span className="font-semibold">{index + 1}.</span> {question}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="max-w-xs">-</div>
                                                    )}
                                                </td>
                                                <td className="text-center align-top">
                                                    {item.leadingGap_area_by_identified_AI_video_analysis_count || "0"}
                                                </td>
                                                <td className="align-top">
                                                    {coachActionPlans.length > 0 ? (
                                                        <div className="max-w-xs max-h-32 overflow-y-auto">
                                                            {coachActionPlans.map((actionPlan, index) => (
                                                                <div key={index} className="text-xs mb-2 p-1 break-words whitespace-normal border-b border-gray-100 last:border-b-0">
                                                                    <span className="font-semibold">{index + 1}.</span> {actionPlan}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="max-w-xs">-</div>
                                                    )}
                                                </td>
                                                <td className="text-center align-top">
                                                    {item.leading_action_items_by_coach_count || "0"}
                                                </td>
                                                <td className="align-top">
                                                    {aiVideoActionPlans.length > 0 ? (
                                                        <div className="max-w-xs max-h-32 overflow-y-auto">
                                                            {aiVideoActionPlans.map((actionPlan, index) => (
                                                                <div key={index} className="text-xs mb-2 p-1 break-words whitespace-normal border-b border-gray-100 last:border-b-0">
                                                                    <span className="font-semibold">{index + 1}.</span> {actionPlan}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="max-w-xs">-</div>
                                                    )}
                                                </td>
                                                <td className="text-center align-top">
                                                    {item.leading_action_items_by_ai_through_teacher_video_count || "0"}
                                                </td>
                                                <td className="align-top">
                                                    {aiQuestionnaireActionPlans.length > 0 ? (
                                                        <div className="max-w-xs max-h-32 overflow-y-auto">
                                                            {aiQuestionnaireActionPlans.map((actionPlan, index) => (
                                                                <div key={index} className="text-xs mb-2 p-1 break-words whitespace-normal border-b border-gray-100 last:border-b-0">
                                                                    <span className="font-semibold">{index + 1}.</span> {actionPlan}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    ) : (
                                                        <div className="max-w-xs">-</div>
                                                    )}
                                                </td>
                                                <td className="text-center align-top">
                                                    {item.leading_action_items_by_ai_through_teacher_questionnaire_count || "0"}
                                                </td>
                                                <td className="align-top">-</td>
                                                <td className="text-center align-top">-</td>
                                            </tr>
                                        );
                                    }) : (
                                        <tr className="align-top">
                                            <td colSpan="100%" className="text-center text-lg align-top">No Data Found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>}

                    {activeTab === "tab8" && <div className="common-table-wrapper m-0">
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr>
                                        <th className='text-center align-top'>Sr.No.</th>
                                        <th className='align-top'>Indicator</th>

                                        <th className='align-top'>Total <br />
                                            observation
                                        </th>
                                        <th className='align-top'>
                                            Month/time <br />
                                            range
                                        </th>
                                        <th className='align-top'>
                                            Number of <br />
                                            marked no
                                        </th>
                                        <th className='align-top'>
                                            Probe A
                                        </th>
                                        <th className='align-top'>
                                            Number <br />
                                            Probe A
                                        </th>
                                        <th className='align-top'>
                                            Probe B
                                        </th>
                                        <th className='align-top'>
                                            Number <br />
                                            Probe B
                                        </th>
                                        <th className='align-top'>
                                            Probe C
                                        </th>
                                        <th className='align-top'>
                                            Number <br />
                                            Probe C
                                        </th>
                                        <th className='align-top'>
                                            Probe D
                                        </th>
                                        <th className='align-top'>
                                            Number <br />
                                            Probe D
                                        </th>
                                        <th className='align-top'>
                                            Probe E
                                        </th>
                                        <th className='align-top'>
                                            Number <br />
                                            Probe E
                                        </th>
                                        <th className='align-top'>
                                            Indicator <br />
                                            selected for
                                            <br />
                                            feedback
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {user?.length > 0 ? (
                                        user.map((data, i) => (
                                            <tr key={data?._id} className="align-top">
                                                <td className="text-center align-top">{indexNumber + i + 1}</td>
                                                <td className="align-top">
                                                    <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                        {data?.question}
                                                    </div>
                                                </td>

                                                <td className="align-top">{data?.total_observation || 0}</td>
                                                <td className="align-top">{data?.month_time || "-"}</td>
                                                <td className="align-top">{data?.total_number_of_question_no || 0}</td>
                                                {["A", "B", "C", "D", "E"].map((probe, idx) => {
                                                    const reason = data?.question_reason?.[idx];
                                                    return (
                                                        <React.Fragment key={probe}>
                                                            <td className="align-top">
                                                                <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                                    {reason?.reason || "-"}
                                                                </div>
                                                            </td>
                                                            <td className="align-top">{reason?.selectedCount ?? 0}</td>
                                                        </React.Fragment>
                                                    );
                                                })}
                                                <td className="align-top">
                                                    <div className="max-h-24 overflow-y-auto break-words whitespace-normal text-sm  rounded p-2">
                                                        {data?.question}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr className="align-top">
                                            <td colSpan="100%">
                                                <h6 className="text-center text-lg align-top">No Data Found.</h6>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>}
                </div>
                <Row className=" px-2 mb-4 py-2">
                    <Col md={12}>
                        <Pagination
                            data={user}
                            indexNumber={indexNumber}
                            totalPage={totalPages}
                            setPage={setPage}
                            page={page}
                            paginationHandler={paginationHandler}
                            total={total}
                        />
                    </Col>
                </Row>
            </div>

            <Toastify />
        </>
    );
}

export default Reports;
